<template>
  <Button
    color="primary"
    variant="outlined"
    data-test-id="buy-box-request-date-button"
    class="px-2 rounded-md grow text-xs flex items-center hover:bg-white hover:text-teal-900"
    @click="handleClick"
  >
    <EditPenIcon class="mr-1" />
    {{ $t('product.show.noAvailableDatesBox.ctaTextOnlyProposeDate') }}
  </Button>
</template>
<script setup lang="ts">
import EditPenIcon from '@/public/icons/edit-pen.svg?component'

const { toggleDateRequestSidebar } = useUiState()
const emit = defineEmits(['click:request-date'])
const handleClick = () => {
  emit('click:request-date')
  toggleDateRequestSidebar(true, 'buy_box')
}
</script>
